import React, {FC, useState, useEffect} from 'react'
import Form from 'react-bootstrap/Form';

// ... existing code ...

type Props = {
  id: string
  isActive: boolean
  onChange: (id: string, newValue: boolean) => void // Signature corrigée
}

export const ToggleButton: FC<Props> = ({ id, isActive, onChange }) => {
  const [isChecked, setIsChecked] = useState(isActive);

  const handleSwitchChange = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange(id, newValue); 
  };
  ;

  useEffect(() => {
    setIsChecked(isActive);
  }, [isActive]);

  return (
    <Form>
      <Form.Check
        type='switch'
        id={`toggle-${id}`}
        label=''
        checked={isChecked}
        onChange={handleSwitchChange}
      />
    </Form>
  );
};